<ng-container *ngIf="!allLoaded && termsOK && !aggregatedError && !isFinishing">
  <app-spinner class="full-size-spinner"></app-spinner>
</ng-container>

<ng-container *ngIf="!termsOK">
  <app-ag-terms-conditions
    (buttonCancel)="cancelTerms()"
    (buttonAllow)="allowTerms()"
    (buttonAllowSantander)="allowTermsSantander()"
  ></app-ag-terms-conditions>
</ng-container>

<ng-container *ngIf="isFinishing">
  <div class="main-container">
    <div class="flex flex-col justify-center items-center mb-5">
      <app-spinner class="w-full py-4"></app-spinner>
      <h2 class="w-full text-center">
        <strong>{{ "FINALIZING" | translate }}</strong>
      </h2>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="allLoaded && termsOK && !aggregatedError && !isFinishing">
  <div class="entities-container">
    <div class="entities-title">
      <span>{{
        "Selecciona los bancos donde tienes ingresos y gastos" | translate
      }}</span>
      <span>{{ "Solo cuentas donde estés como titular" | translate }}</span>
    </div>
    <div class="entities-selected">
      <button
        class="entity"
        type="button"
        *ngFor="let entity of getEntitiesToDisplay()"
        [disabled]="!isCurrentlySelected(entity)"
        [attr.aria-label]="'Eliminar ' + entity.name"
      >
        <span class="name">{{ entity.name }}</span>
        <span
          class="close"
          *ngIf="isCurrentlySelected(entity)"
          aria-hidden="true"
          (click)="removeSelectedEntity(entity)"
          (keydown.enter)="removeSelectedEntity(entity)"
          >x</span
        >
      </button>
    </div>
    <div
      class="my-2"
      [ngStyle]="{ display: !onlySantanderQueryParam ? 'none' : 'block' }"
      *ngIf="canAggregateOnlySantander()"
    >
      <app-san-checkbox
        (changeCheckbox)="
          onlyAggregateSantander = !onlyAggregateSantander;
          onlyAggregateSantander && goToAggregateSantander($event)
        "
        [isChecked]="onlyAggregateSantander"
      >
        <span [innerHTML]="'ONLYSANTANDER' | translate"></span>
      </app-san-checkbox>
    </div>
    <div class="entities-header" *ngIf="!onlyAggregateSantander">
      <span>Bancos más comunes</span>
      <div class="see-all" (click)="openModal()">
        <span>Ver todos</span>
        <div class="search-icon"></div>
      </div>
    </div>
    <div class="entities-wrapper" *ngIf="!onlyAggregateSantander">
      <ng-container *ngFor="let entity of filteredEntities; let i = index">
        <div
          *ngIf="i < 8"
          [ngClass]="entity.disabled ? 'entity disabled' : 'entity'"
        >
          <button
            type="button"
            [title]="entity.name"
            [id]="entity.robotName"
            [class]="entityButtonClasses(entity)"
            (click)="selectEntity(entity)"
          >
            <ng-container *ngIf="entity.image">
              <div class="entity-radio">
                <div></div>
              </div>
              <img
                class="entity-image"
                [src]="entity.image"
                [alt]="entity.name"
              />
              <span class="entity-name">{{ entity.name }}</span>
            </ng-container>
            <ng-container *ngIf="!entity.image">
              <div class="entity-radio">
                <div></div>
              </div>
              <img
                class="entity-image"
                [src]="'assets/banks/bank-icon.svg'"
                [alt]="entity.name"
              />
              <span class="entity-name">{{ entity.name }}</span>
            </ng-container>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="aggregatedError">
  <app-ag-error
    *ngIf="!finishError"
    [noCancelButton]="true"
    [errorTitle]="'errors.500.title' | translate"
    [errorDescription]="'errors.500.description' | translate"
    [buttonText]="'general.out' | translate"
    (buttonClick)="goOutAppWithError()"
  ></app-ag-error>
  <app-ag-error
    *ngIf="finishError"
    [noCancelButton]="true"
    [errorTitle]="'errors.finish.title' | translate"
    [errorDescription]="'errors.finish.description' | translate"
    [buttonText]="'general.finish' | translate"
    (buttonClick)="finish(!isCancel, false)"
  ></app-ag-error>
</ng-container>

<app-ag-error
  *ngIf="titularityError"
  [noCancelButton]="true"
  [errorTitle]="'TITULARITYERROR.TITLE' | translate"
  [errorDescription]="'TITULARITYERROR.DESCRIPTION' | translate"
  [buttonText]="'general.out' | translate"
  (buttonClick)="goOutAppWithError()"
></app-ag-error>

<app-ag-button-set
  *ngIf="!isFinishing && allLoaded && !onlyAggregateSantander"
  [primaryLabel]="'Contactar con tu/s entidad/es'"
  [primaryDisabled]="checkEntities()"
  [tertiaryLabel]="'Cancelar'"
  (continueButton)="navigateToAdvise()"
  (cancelButton)="finish(isCancel, false)"
  (backButton)="finish(isCancel, true)"
></app-ag-button-set>

<app-ag-button-set
  *ngIf="onlyAggregateSantander && !isFinishing && allLoaded"
  [primaryLabel]="'Finalizar'"
  (continueButton)="finish(!isCancel, false)"
  [tertiaryLabel]="'Cancelar'"
  [primaryDisabled]="!this.visibilityFinish"
  (cancelButton)="goOutApp(isCancel)"
  (backButton)="goOutApp(!isCancel)"
></app-ag-button-set>

<app-ag-modal-container
  *ngIf="showModal"
  class="entities-modal"
  (clickClose)="closeModal()"
>
  <section class="mb-6">
    <h2 class="mb-3">
      <strong
        >{{ "entities.select-entity.1" | translate }}&nbsp;{{
          "entities.select-entity.2" | translate
        }}</strong
      >
    </h2>
    <label for="modalFilterText" class="search-icon">
      <input
        class="w-full form-control filtent"
        type="text"
        id="modalFilterText"
        [placeholder]="'entities.search-entity' | translate"
        autocomplete="off"
        aria-label="Buscar banco"
        [(ngModel)]="modalFilterText"
        (ngModelChange)="updateModalEntities()"
        maxlength="80"
      />
      <img
        class="delete-icon"
        src="assets/icons/delete.svg"
        *ngIf="modalFilterText.length > 0"
        (click)="modalFilterText = ''; updateModalEntities()"
        (keydown.enter)="modalFilterText = ''; updateModalEntities()"
        alt="Limpiar búsqueda"
      />
    </label>
  </section>
  <div class="modal-entities">
    <button
      *ngFor="let entity of otherEntities; let i = index"
      type="button"
      [title]="entity.name"
      [id]="entity.robotName"
      [class]="entityButtonClasses(entity)"
      (click)="selectEntity(entity)"
    >
      <div class="entity modal-entity-content">
        <ng-container *ngIf="entity.image">
          <span>{{ entity.name }}</span>
          <img
            class="entity-image"
            width="45px"
            [src]="entity.image"
            [alt]="entity.name"
          />
        </ng-container>
        <ng-container *ngIf="!entity.image">
          <span>{{ entity.name }}</span>
          <img
            class="entity-image"
            width="45px"
            [src]="'assets/banks/bank-icon.svg'"
            [alt]="entity.name"
          />
        </ng-container>
      </div>
      <div class="checkbox"></div>
    </button>
  </div>
</app-ag-modal-container>
